<template>
  <div class="basket-comment">
    <!-- Кнопка раскрытия комментария -->
    <div
      class="grid grid-cols-[20px_1fr_auto] gap-5 items-center p-5 cursor-pointer"
      @click="toggleComment"
    >
      <UIcon name="i-heroicons-chat-bubble-oval-left-ellipsis-16-solid" class="w-5 h-5" />
      <p>Комментарий к заказу</p>
      <UIcon
        name="i-heroicons-chevron-right-20-solid"
        class="w-5 h-5 transition-all ease-in-out duration-300"
        :class="{ 'transform rotate-90': isExpanded }"
      />
    </div>
    
    <!-- Поле для ввода комментария -->
    <div v-if="isExpanded" class="p-2">
      <UiKitTextarea
        v-model="commentText"
        placeholder="Ваши пожелания"
        :rows="5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  comment: string
  isShowComment: boolean
}

interface Emits {
  (e: 'update:comment', value: string): void
  (e: 'update:isShowComment', value: boolean): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

/**
 * Реактивная ссылка на состояние раскрытия
 */
const isExpanded = computed({
  get: () => props.isShowComment,
  set: (value: boolean) => emit('update:isShowComment', value),
})

/**
 * Реактивная ссылка на текст комментария
 */
const commentText = computed({
  get: () => props.comment,
  set: (value: string) => emit('update:comment', value),
})

/**
 * Переключает видимость блока комментария
 */
function toggleComment(): void {
  isExpanded.value = !isExpanded.value
}
</script>

<style scoped lang="scss">
.basket-comment {
  @apply mb-4;
}
</style>